enum QueryStatus {
  WAITING = "WAITING",
  ERROR = "ERROR",
  SUCCESSFUL = "SUCCESSFUL",
  UNDETERMINED = "UNDETERMINED",
}

export default QueryStatus;
